import React from 'react';
import { useSelector } from "react-redux";
import levarLogo from '../../assets/images/loading/levAR_logo.svg'; // white

const ScreenLoader = React.memo(props => {
  const { settings } = useSelector(state => ({
    settings: state.settings,
  }));

  return (
    <div className='ScreenLoader'>
      <img src={ settings.logo_file ? settings.logo_file : levarLogo } className='Loading-logo' alt='loading' />
    </div>
  )
});

export default ScreenLoader;
